import React from 'react';
import Icon from '../../../components/AppIcon';


const PlaylistSection = ({ playlists, onPlaylistSelect }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="ListVideo" size={24} color="var(--color-primary)" />
          Listes de lecture
        </h2>
      </div>
      <div className="space-y-3">
        {playlists?.map((playlist) => (
          <div
            key={playlist?.id}
            onClick={() => onPlaylistSelect(playlist)}
            className="flex items-center gap-3 p-3 rounded-lg border border-border hover:bg-muted cursor-pointer transition-colors duration-200"
          >
            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="PlayCircle" size={24} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground truncate">
                {playlist?.title}
              </h3>
              <p className="text-xs text-muted-foreground">
                {playlist?.videoCount} vidéos • {playlist?.duration}
              </p>
            </div>
            <div className="flex items-center gap-2">
              {playlist?.progress > 0 && (
                <div className="text-xs font-medium text-primary">
                  {playlist?.progress}%
                </div>
              )}
              <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlaylistSection;